import { render } from "./Loading-Spiner.vue?vue&type=template&id=726b9db6&scoped=true"
import script from "./Loading-Spiner.vue?vue&type=script&lang=js"
export * from "./Loading-Spiner.vue?vue&type=script&lang=js"

import "./Loading-Spiner.vue?vue&type=style&index=0&id=726b9db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726b9db6"]])

export default __exports__